import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './visitorNav.css';
import logoWhite from '../../assets/logo white.png'
import logoBlack from '../../assets/logo black.jpg'
import { useTheme } from '../../context/ThemeContext';
import { Link } from 'react-router-dom';
import LanguageSelector from '../LanguageSelector';

const Navbar = () => {
  const { theme } = useTheme();
  const logo = theme === 'dark' ? logoWhite : logoBlack;
  const [visitorNav, setVisitorNav] = useState(false);
  const { t } = useTranslation();

  const toggleVisitorNav = () => {
    setVisitorNav(!visitorNav);
  }
  return (
    <div className='navbar-container'>
        <nav>
            <Link to='/'><img className='logo' src={logo} alt="" /></Link>
            <ul className='nav-links'>
                <li><Link className='link' to="/">{t('nav.home')} <i className="fa fa-home"></i></Link></li>
                <li><Link className='link' to="/">{t('nav.listings')} <i className="fa fa-building"></i></Link></li>
                <li><Link className='link' to="/">{t('nav.service_provider')} <i className="fa fa-gear"></i></Link></li>
                <li><Link className='link' to="/admin/login">{t('nav.admin_login')} <i className="fa fa-user"></i></Link></li>
                <li><Link className='link' to="/hotel/login">{t('nav.hotel_login')} <i className="fa fa-user"></i></Link></li>
                {/* <li><Link className='link' to="/">Login <i className="fa fa-user"></i></Link></li> */}
                <li className=''><Link className='btn' to="/register"> <button className='btn btn-primary'>{t('nav.register')}</button></Link></li>
                <li className='nav-language-selector'><LanguageSelector /></li>
            </ul>
            <i onClick={toggleVisitorNav} className={`bars ${visitorNav ? 'fa fa-times' : 'fa fa-bars'}`}></i>
            {visitorNav && <>
              <ul className='fade-up mobile-nav-links'>
                <li><Link className='links' to="/">{t('nav.home')} <i className="fa fa-home"></i></Link></li>
                <li><Link className='links' to="/">{t('nav.listings')} <i className="fa fa-building"></i></Link></li>
                <li><Link className='links' to="/">{t('nav.service_provider')} <i className="fa fa-gear"></i></Link></li>
                <li><Link className='links' to="/admin/login">{t('nav.admin_login')} <i className="fa fa-user"></i></Link></li>
                <li><Link className='links' to="/hotel/login">{t('nav.hotel_login')} <i className="fa fa-user"></i></Link></li>
                <li className=''><Link className='btn' to="/"> <button className='btn btn-primary'>{t('nav.register')}</button></Link></li>
                <li className='nav-language-selector'><LanguageSelector /></li>
            </ul>
            </>}
        </nav>
    </div>
  )
}

export default Navbar
